import * as React from 'react';
import { createIcon } from '../createIcon';
import * as styles from './styles.css';

function Loader() {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-fill-rule": "stroke",
    strokeWidth: "7",
    strokeLinecap: "round",
    cx: "32",
    cy: "32",
    r: "28"
  }));
}

export var LoaderIcon = createIcon(Loader, {
  containerClass: styles['loader']
});